function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1924(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 7.12,
    height: 1.43,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.2383333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 0.715,
    fontFamily: "Arial"
  }, "\n        Loving\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1.43,
    width: 7.12,
    height: 1.63,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.23285714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 2.245,
    fontFamily: "Arial"
  }, "\n        Winkler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 3.06,
    width: 7.12,
    height: 4.08,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.8160000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 5.1,
    fontFamily: "Arial"
  }, "\n        Upton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 7.13,
    width: 7.12,
    height: 7.23,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0171428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 10.745000000000001,
    fontFamily: "Arial"
  }, "\n        Andrews\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.37,
    width: 7.12,
    height: 7.34,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0171428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 18.04,
    fontFamily: "Arial"
  }, "\n        Cochran\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.7,
    width: 7.12,
    height: 7.64,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 25.52,
    fontFamily: "Arial"
  }, "\n        Kenedy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 29.34,
    width: 7.12,
    height: 8.86,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 33.769999999999996,
    fontFamily: "Arial"
  }, "\n        King\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 38.21,
    width: 7.12,
    height: 9.37,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.424
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 42.895,
    fontFamily: "Arial"
  }, "\n        Moore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 47.58,
    width: 7.12,
    height: 9.58,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0171428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 52.37,
    fontFamily: "Arial"
  }, "\n        Hockley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.16,
    width: 7.12,
    height: 11.11,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7911111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 62.714999999999996,
    fontFamily: "Arial"
  }, "\n        Glasscock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 68.27,
    width: 7.12,
    height: 11.41,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 73.975,
    fontFamily: "Arial"
  }, "\n        Yoakum\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 79.68,
    width: 7.12,
    height: 11.92,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7911111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 85.64,
    fontFamily: "Arial"
  }, "\n        Culberson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.6,
    width: 7.12,
    height: 14.47,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 98.835,
    fontFamily: "Arial"
  }, "\n        Hudspeth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 106.07,
    width: 7.12,
    height: 14.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 113.40499999999999,
    fontFamily: "Arial"
  }, "\n        Reagan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 120.74,
    width: 7.12,
    height: 15.79,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.424
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 128.635,
    fontFamily: "Arial"
  }, "\n        Ector\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 136.54,
    width: 7.12,
    height: 16.1,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 144.59,
    fontFamily: "Arial"
  }, "\n        Jim_Hogg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 152.63,
    width: 7.12,
    height: 17.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 161.34,
    fontFamily: "Arial"
  }, "\n        Borden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 170.06,
    width: 7.12,
    height: 18.54,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 179.33,
    fontFamily: "Arial"
  }, "\n        Crockett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 188.6,
    width: 7.12,
    height: 18.75,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 197.975,
    fontFamily: "Arial"
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 207.35,
    width: 7.12,
    height: 22.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 218.70999999999998,
    fontFamily: "Arial"
  }, "\n        McMullen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 230.07,
    width: 7.12,
    height: 23.84,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 241.98999999999998,
    fontFamily: "Arial"
  }, "\n        Hutchinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 253.92,
    width: 7.12,
    height: 24.76,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0171428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 266.3,
    fontFamily: "Arial"
  }, "\n        Hartley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 278.68,
    width: 7.12,
    height: 25.47,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 291.415,
    fontFamily: "Arial"
  }, "\n        Bailey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 304.15,
    width: 7.12,
    height: 27.31,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 317.80499999999995,
    fontFamily: "Arial"
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 331.46,
    width: 7.12,
    height: 27.41,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 345.16499999999996,
    fontFamily: "Arial"
  }, "\n        Sterling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 358.86,
    width: 7.12,
    height: 27.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 372.565,
    fontFamily: "Arial"
  }, "\n        Sutton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 386.27,
    width: 7.12,
    height: 27.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 400.125,
    fontFamily: "Arial"
  }, "\n        Oldham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413.99,
    width: 7.12,
    height: 27.92,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 427.95,
    fontFamily: "Arial"
  }, "\n        Ward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 441.91,
    width: 7.12,
    height: 28.33,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0171428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 456.07500000000005,
    fontFamily: "Arial"
  }, "\n        Aransas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 470.23,
    width: 7.12,
    height: 29.34,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.424
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 484.90000000000003,
    fontFamily: "Arial"
  }, "\n        Irion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 499.58,
    width: 7.12,
    height: 30.57,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0171428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 514.865,
    fontFamily: "Arial"
  }, "\n        Sherman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 530.15,
    width: 7.12,
    height: 32.1,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 546.1999999999999,
    fontFamily: "Arial"
  }, "\n        Kinney\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 562.24,
    width: 7.12,
    height: 32.2,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.0171428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 578.34,
    fontFamily: "Arial"
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 594.44,
    width: 7.12,
    height: 34.75,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1866666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 611.815,
    fontFamily: "Arial"
  }, "\n        Parmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 629.18,
    width: 7.12,
    height: 35.36,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0171428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 646.8599999999999,
    fontFamily: "Arial"
  }, "\n        Roberts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 664.54,
    width: 7.12,
    height: 35.46,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 3.56,
    y: 682.27,
    fontFamily: "Arial"
  }, "\n        Presidio\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 0,
    width: 20.81,
    height: 12.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 17.525,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Hansford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.92,
    y: 0,
    width: 20.92,
    height: 12.65,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.2650000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.38,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Schleicher\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.85,
    y: 0,
    width: 21.15,
    height: 12.65,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 59.425,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Castro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 0,
    width: 24.42,
    height: 12.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.21000000000001,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.42,
    y: 0,
    width: 24.88,
    height: 12.65,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8071428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.86,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Willacy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.3,
    y: 0,
    width: 25.28,
    height: 12.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.94,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Gaines\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.58,
    y: 0,
    width: 25.62,
    height: 12.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8071428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 157.39000000000001,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Midland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.2,
    y: 0,
    width: 25.97,
    height: 12.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.185,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Zavala\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.17,
    y: 0,
    width: 26.89,
    height: 12.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4055555555555557
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.61499999999998,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Somervell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 223.06,
    y: 0,
    width: 27.17,
    height: 12.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.645,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Kent\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.23,
    y: 0,
    width: 27.29,
    height: 12.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8071428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.875,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Briscoe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 277.52,
    y: 0,
    width: 28.15,
    height: 12.65,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.59499999999997,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Maverick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.66,
    y: 0,
    width: 28.26,
    height: 12.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 319.79,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Dimmit\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.92,
    y: 0,
    width: 28.55,
    height: 12.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.195,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Real\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.47,
    y: 0,
    width: 28.55,
    height: 12.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.745,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Zapata\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.02,
    y: 0,
    width: 28.66,
    height: 12.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.34999999999997,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Brewster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.68,
    y: 0,
    width: 29.06,
    height: 12.65,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.21,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Lamb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.75,
    y: 0,
    width: 29.35,
    height: 12.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.425,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Reeves\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.1,
    y: 0,
    width: 30.1,
    height: 12.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.15000000000003,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Motley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.19,
    y: 0,
    width: 31.01,
    height: 12.65,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.695,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        La_Salle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.2,
    y: 0,
    width: 31.24,
    height: 12.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.82,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Chambers\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.45,
    y: 0,
    width: 31.87,
    height: 12.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4055555555555557
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 586.385,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Armstrong\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 602.32,
    y: 0,
    width: 32.22,
    height: 12.65,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4055555555555557
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.4300000000001,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Ochiltree\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.54,
    y: 0,
    width: 32.33,
    height: 12.65,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8071428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 650.7049999999999,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Edwards\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 666.87,
    y: 0,
    width: 33.13,
    height: 12.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1083333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.4350000000001,
    y: 6.325,
    fontFamily: "Arial"
  }, "\n        Menard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 12.65,
    width: 23.86,
    height: 19.54,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 22.42,
    fontFamily: "Arial"
  }, "\n        Hemphill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 32.19,
    width: 23.86,
    height: 19.99,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3316666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 42.184999999999995,
    fontFamily: "Arial"
  }, "\n        Cottle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 52.18,
    width: 23.86,
    height: 20.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.024
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 62.24,
    fontFamily: "Arial"
  }, "\n        Pecos\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 72.29,
    width: 23.86,
    height: 21.27,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9336363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 82.92500000000001,
    fontFamily: "Arial"
  }, "\n        San_Jacinto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 93.56,
    width: 23.86,
    height: 21.48,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.58
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 104.3,
    fontFamily: "Arial"
  }, "\n        Kimble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 115.05,
    width: 23.86,
    height: 21.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.346
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 125.91499999999999,
    fontFamily: "Arial"
  }, "\n        Foard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 136.77,
    width: 23.86,
    height: 21.82,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.364
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 147.68,
    fontFamily: "Arial"
  }, "\n        Mason\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 158.59,
    width: 23.86,
    height: 21.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8208333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 169.51500000000001,
    fontFamily: "Arial"
  }, "\n        Throckmorton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 180.44,
    width: 23.86,
    height: 23.18,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.318
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 192.03,
    fontFamily: "Arial"
  }, "\n        Deaf_Smith\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 203.62,
    width: 23.86,
    height: 23.28,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 215.26,
    fontFamily: "Arial"
  }, "\n        Coke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 226.9,
    width: 23.86,
    height: 23.67,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.734
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 238.735,
    fontFamily: "Arial"
  }, "\n        Starr\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 250.57,
    width: 23.86,
    height: 23.73,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.955
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 262.435,
    fontFamily: "Arial"
  }, "\n        Concho\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 274.3,
    width: 23.86,
    height: 24.55,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.965
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 286.575,
    fontFamily: "Arial"
  }, "\n        Frio\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 298.85,
    width: 23.86,
    height: 25.68,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4085714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 311.69,
    fontFamily: "Arial"
  }, "\n        Randall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 324.53,
    width: 23.86,
    height: 26.71,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4085714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 337.885,
    fontFamily: "Arial"
  }, "\n        Swisher\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 351.23,
    width: 23.86,
    height: 27.41,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4085714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 364.935,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 378.64,
    width: 23.86,
    height: 28.08,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4085714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 392.68,
    fontFamily: "Arial"
  }, "\n        Bandera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 406.72,
    width: 23.86,
    height: 28.38,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4085714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 420.91,
    fontFamily: "Arial"
  }, "\n        Refugio\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 435.1,
    width: 23.86,
    height: 28.68,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.772
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 449.44,
    fontFamily: "Arial"
  }, "\n        Garza\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 463.78,
    width: 23.86,
    height: 28.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 478.15,
    fontFamily: "Arial"
  }, "\n        Comanche\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 492.53,
    width: 23.86,
    height: 28.81,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9766666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 506.93499999999995,
    fontFamily: "Arial"
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 521.33,
    width: 23.86,
    height: 28.84,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 535.75,
    fontFamily: "Arial"
  }, "\n        Lipscomb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 550.17,
    width: 23.86,
    height: 28.93,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9766666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 564.635,
    fontFamily: "Arial"
  }, "\n        Carson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 579.1,
    width: 23.86,
    height: 30.02,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8353846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 594.11,
    fontFamily: "Arial"
  }, "\n        Collingsworth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 609.12,
    width: 23.86,
    height: 30.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.651111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 624.19,
    fontFamily: "Arial"
  }, "\n        Jim_Wells\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 639.26,
    width: 23.86,
    height: 30.32,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.651111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 654.42,
    fontFamily: "Arial"
  }, "\n        Val_Verde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.12,
    y: 669.58,
    width: 23.86,
    height: 30.42,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.772
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 19.05,
    y: 684.7900000000001,
    fontFamily: "Arial"
  }, "\n        Terry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 12.65,
    width: 25.86,
    height: 28.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6942857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 43.91,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Dickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.84,
    y: 12.65,
    width: 26.42,
    height: 28.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 70.05000000000001,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Live_Oak\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.26,
    y: 12.65,
    width: 26.47,
    height: 28.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.495,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Tyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.72,
    y: 12.65,
    width: 26.49,
    height: 28.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 122.965,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Dallam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.22,
    y: 12.65,
    width: 26.65,
    height: 28.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.441666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.545,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.86,
    y: 12.65,
    width: 27.05,
    height: 28.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0055555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.38500000000002,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Stonewall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.92,
    y: 12.65,
    width: 27.31,
    height: 28.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.575,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Llano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.22,
    y: 12.65,
    width: 27.33,
    height: 28.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.885,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Blanco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.55,
    y: 12.65,
    width: 27.84,
    height: 28.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.568
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.47,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Rains\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.39,
    y: 12.65,
    width: 28.32,
    height: 28.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.55,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Archer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.71,
    y: 12.65,
    width: 28.78,
    height: 28.6,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.085714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.09999999999997,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Kleberg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.49,
    y: 12.65,
    width: 29.18,
    height: 28.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.085714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 344.08,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 358.67,
    y: 12.65,
    width: 29.49,
    height: 28.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.415,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Baylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.15,
    y: 12.65,
    width: 29.64,
    height: 28.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.085714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 402.96999999999997,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.79,
    y: 12.65,
    width: 29.89,
    height: 28.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.735,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Morris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 447.68,
    y: 12.65,
    width: 30.15,
    height: 28.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.755,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Gray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.83,
    y: 12.65,
    width: 30.2,
    height: 28.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.93,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Anderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 508.02,
    y: 12.65,
    width: 30.88,
    height: 28.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.46,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Sabine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.91,
    y: 12.65,
    width: 31.24,
    height: 28.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.085714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.53,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Kendall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 570.14,
    y: 12.65,
    width: 31.29,
    height: 28.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.785,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Donley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.43,
    y: 12.65,
    width: 31.84,
    height: 28.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.3499999999999,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Hood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.27,
    y: 12.65,
    width: 32.93,
    height: 28.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.735,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 666.2,
    y: 12.65,
    width: 33.8,
    height: 28.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.766666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.1,
    y: 26.950000000000003,
    fontFamily: "Arial"
  }, "\n        Goliad\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 41.25,
    width: 32.06,
    height: 30.21,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.77625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 56.355000000000004,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 71.46,
    width: 32.06,
    height: 30.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 86.75999999999999,
    fontFamily: "Arial"
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 102.05,
    width: 32.06,
    height: 30.89,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4322222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 117.495,
    fontFamily: "Arial"
  }, "\n        Childress\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 132.94,
    width: 32.06,
    height: 31.41,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.92625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 148.645,
    fontFamily: "Arial"
  }, "\n        Atascosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 164.35,
    width: 32.06,
    height: 31.48,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.296
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 180.09,
    fontFamily: "Arial"
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 195.83,
    width: 32.06,
    height: 31.66,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 211.66000000000003,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 227.49,
    width: 32.06,
    height: 31.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 243.41,
    fontFamily: "Arial"
  }, "\n        Hardeman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 259.33,
    width: 32.06,
    height: 32.02,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 275.34,
    fontFamily: "Arial"
  }, "\n        Camp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 291.35,
    width: 32.06,
    height: 32.7,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 307.70000000000005,
    fontFamily: "Arial"
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 324.05,
    width: 32.06,
    height: 32.72,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.343333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 340.41,
    fontFamily: "Arial"
  }, "\n        Howard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 356.77,
    width: 32.06,
    height: 32.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.9145454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 373.23499999999996,
    fontFamily: "Arial"
  }, "\n        Shackelford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 389.7,
    width: 32.06,
    height: 33.04,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.343333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 406.21999999999997,
    fontFamily: "Arial"
  }, "\n        Waller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 422.74,
    width: 32.06,
    height: 33.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 439.36,
    fontFamily: "Arial"
  }, "\n        Jack\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 455.98,
    width: 32.06,
    height: 33.26,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 472.61,
    fontFamily: "Arial"
  }, "\n        Rockwall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 489.24,
    width: 32.06,
    height: 33.94,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 506.21000000000004,
    fontFamily: "Arial"
  }, "\n        Lynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 523.18,
    width: 32.06,
    height: 34.26,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.412000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 540.31,
    fontFamily: "Arial"
  }, "\n        Mills\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 557.44,
    width: 32.06,
    height: 35.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.343333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 575.0100000000001,
    fontFamily: "Arial"
  }, "\n        Crosby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 592.59,
    width: 32.06,
    height: 35.32,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4661538461538464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 610.25,
    fontFamily: "Arial"
  }, "\n        San_Augustine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 627.91,
    width: 32.06,
    height: 35.68,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5622222222222226
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 645.75,
    fontFamily: "Arial"
  }, "\n        Wilbarger\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.98,
    y: 663.59,
    width: 32.06,
    height: 36.41,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.343333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 47.010000000000005,
    y: 681.7950000000001,
    fontFamily: "Arial"
  }, "\n        Scurry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 41.25,
    width: 32.32,
    height: 37.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.464
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.2,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Gregg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.35,
    y: 41.25,
    width: 32.66,
    height: 37.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2659999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.67999999999999,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.02,
    y: 41.25,
    width: 32.72,
    height: 37.49,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.674285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.38,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.74,
    y: 41.25,
    width: 33.17,
    height: 37.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.528333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.32500000000002,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Uvalde\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.9,
    y: 41.25,
    width: 33.24,
    height: 37.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.52,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.15,
    y: 41.25,
    width: 33.71,
    height: 37.49,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.815714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.005,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.86,
    y: 41.25,
    width: 34.69,
    height: 37.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 278.20500000000004,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Webb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 295.55,
    y: 41.25,
    width: 34.98,
    height: 37.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.04,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Kerr\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.53,
    y: 41.25,
    width: 35.45,
    height: 37.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.8625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.255,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.98,
    y: 41.25,
    width: 35.58,
    height: 37.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.116
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.77000000000004,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Nolan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.56,
    y: 41.25,
    width: 35.66,
    height: 37.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9622222222222216
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.39,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        McCulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.22,
    y: 41.25,
    width: 35.7,
    height: 37.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 455.07000000000005,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Lampasas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.92,
    y: 41.25,
    width: 37.38,
    height: 37.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.61,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.31,
    y: 41.25,
    width: 37.42,
    height: 37.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.355
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.02,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.73,
    y: 41.25,
    width: 37.61,
    height: 37.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.498
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.535,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Titus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585.34,
    y: 41.25,
    width: 37.63,
    height: 37.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.68625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.1550000000001,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Callahan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 622.97,
    y: 41.25,
    width: 38.43,
    height: 37.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.496666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 642.1850000000001,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Bee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 661.4,
    y: 41.25,
    width: 38.6,
    height: 37.49,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.248333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.6999999999999,
    y: 59.995000000000005,
    fontFamily: "Arial"
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 78.74,
    width: 38.22,
    height: 38.18,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.363333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 97.83,
    fontFamily: "Arial"
  }, "\n        Fisher\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 116.92,
    width: 38.22,
    height: 38.26,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 136.05,
    fontFamily: "Arial"
  }, "\n        San_Saba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 155.18,
    width: 38.22,
    height: 38.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 174.535,
    fontFamily: "Arial"
  }, "\n        Hale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 193.89,
    width: 38.22,
    height: 39.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 213.42499999999998,
    fontFamily: "Arial"
  }, "\n        Burnet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 232.97,
    width: 38.22,
    height: 39.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 252.78,
    fontFamily: "Arial"
  }, "\n        Hays\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 272.59,
    width: 38.22,
    height: 40.63,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 292.905,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 313.22,
    width: 38.22,
    height: 41.52,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 333.98,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 354.74,
    width: 38.22,
    height: 42.36,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 375.92,
    fontFamily: "Arial"
  }, "\n        Panola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 397.1,
    width: 38.22,
    height: 42.68,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.246666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 418.44,
    fontFamily: "Arial"
  }, "\n        Fort_Bend\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 439.78,
    width: 38.22,
    height: 42.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 461.23999999999995,
    fontFamily: "Arial"
  }, "\n        San_Patricio\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 159,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 482.7,
    width: 38.22,
    height: 43.21,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 504.305,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 160,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 525.91,
    width: 38.22,
    height: 43.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.37
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 547.525,
    fontFamily: "Arial"
  }, "\n        Medina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 161,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 569.14,
    width: 38.22,
    height: 43.32,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 590.8,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 162,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 612.46,
    width: 38.22,
    height: 43.66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.246666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 634.2900000000001,
    fontFamily: "Arial"
  }, "\n        Robertson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 163,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 656.13,
    width: 38.22,
    height: 43.87,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.15,
    y: 678.0649999999999,
    fontFamily: "Arial"
  }, "\n        Lubbock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 164,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 78.74,
    width: 40.16,
    height: 42.01,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.34,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 165,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.43,
    y: 78.74,
    width: 40.47,
    height: 42.01,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.745
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.66500000000002,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Grimes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 166,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.9,
    y: 78.74,
    width: 40.96,
    height: 42.01,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.192
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.38,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Young\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 167,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.86,
    y: 78.74,
    width: 40.97,
    height: 42.01,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.552222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 243.34500000000003,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Matagorda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 168,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.83,
    y: 78.74,
    width: 41.32,
    height: 42.01,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.49,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 169,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305.15,
    y: 78.74,
    width: 41.73,
    height: 42.01,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.21625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.015,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Victoria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 170,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.89,
    y: 78.74,
    width: 42.18,
    height: 42.01,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.001666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.97999999999996,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Brazos\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 171,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.07,
    y: 78.74,
    width: 42.36,
    height: 42.01,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.001666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 410.25,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Wilson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 172,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 431.42,
    y: 78.74,
    width: 42.55,
    height: 42.01,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.402
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.695,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Comal\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 173,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.97,
    y: 78.74,
    width: 43.08,
    height: 42.01,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.001666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.51000000000005,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Karnes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 174,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.05,
    y: 78.74,
    width: 44.98,
    height: 42.01,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.001428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.54,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Haskell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 175,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.03,
    y: 78.74,
    width: 45.41,
    height: 42.01,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.201
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.735,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Palo_Pinto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 176,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 607.44,
    y: 78.74,
    width: 45.93,
    height: 42.01,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.25125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.4050000000001,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 177,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 653.36,
    y: 78.74,
    width: 46.64,
    height: 42.01,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.667777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.6800000000001,
    y: 99.74499999999999,
    fontFamily: "Arial"
  }, "\n        Gillespie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 178,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 120.74,
    width: 44.34,
    height: 44.41,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.868
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 142.945,
    fontFamily: "Arial"
  }, "\n        Delta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 179,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 165.15,
    width: 44.34,
    height: 44.87,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 187.585,
    fontFamily: "Arial"
  }, "\n        Burleson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 180,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 210.02,
    width: 44.34,
    height: 45.68,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.926666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 232.86,
    fontFamily: "Arial"
  }, "\n        Tom_Green\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 181,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 255.7,
    width: 44.34,
    height: 45.73,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 278.565,
    fontFamily: "Arial"
  }, "\n        Caldwell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 182,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 301.44,
    width: 44.34,
    height: 47.6,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.390000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 325.24,
    fontFamily: "Arial"
  }, "\n        Upshur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 183,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 349.03,
    width: 44.34,
    height: 48.71,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.390000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 373.385,
    fontFamily: "Arial"
  }, "\n        Parker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 184,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 397.74,
    width: 44.34,
    height: 48.87,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3342857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 422.175,
    fontFamily: "Arial"
  }, "\n        Wharton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 185,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 446.61,
    width: 44.34,
    height: 48.95,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 471.08500000000004,
    fontFamily: "Arial"
  }, "\n        Brazoria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 186,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 495.57,
    width: 44.34,
    height: 49.17,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.390000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 520.155,
    fontFamily: "Arial"
  }, "\n        Bosque\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 187,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 544.73,
    width: 44.34,
    height: 51.7,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 570.58,
    fontFamily: "Arial"
  }, "\n        Colorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 188,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 596.43,
    width: 44.34,
    height: 51.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.3342857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 622.28,
    fontFamily: "Arial"
  }, "\n        Runnels\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 189,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.26,
    y: 648.14,
    width: 44.34,
    height: 51.86,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.926666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.43,
    y: 674.0699999999999,
    fontFamily: "Arial"
  }, "\n        Freestone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 190,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 120.74,
    width: 47.96,
    height: 48.55,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 169.59,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 191,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.56,
    y: 120.74,
    width: 48.72,
    height: 48.55,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.06875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 217.92000000000002,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Harrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 192,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.28,
    y: 120.74,
    width: 48.82,
    height: 48.55,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.06875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.69,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Montague\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 193,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.1,
    y: 120.74,
    width: 48.99,
    height: 48.55,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.1375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.595,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 194,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.09,
    y: 120.74,
    width: 49.14,
    height: 48.55,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.06875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.65999999999997,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Gonzales\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 195,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.23,
    y: 120.74,
    width: 49.9,
    height: 48.55,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.18,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Coleman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 196,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.13,
    y: 120.74,
    width: 50.62,
    height: 48.55,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.44,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Coryell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 197,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.74,
    y: 120.74,
    width: 51.56,
    height: 48.55,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515.52,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Bastrop\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 198,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.3,
    y: 120.74,
    width: 51.62,
    height: 48.55,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.709999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.1099999999999,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Falls\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 199,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.91,
    y: 120.74,
    width: 52.92,
    height: 48.55,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.394444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.37,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Red_River\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 200,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 645.83,
    y: 120.74,
    width: 54.17,
    height: 48.55,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.091666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.9150000000001,
    y: 145.015,
    fontFamily: "Arial"
  }, "\n        Austin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 201,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 169.29,
    width: 50.84,
    height: 51.93,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 195.255,
    fontFamily: "Arial"
  }, "\n        Wise\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 202,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 221.22,
    width: 50.84,
    height: 52.2,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 247.32,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 203,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 273.41,
    width: 50.84,
    height: 52.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.262857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 299.56,
    fontFamily: "Arial"
  }, "\n        Cameron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 204,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 325.71,
    width: 50.84,
    height: 52.33,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.621818181818182
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 351.875,
    fontFamily: "Arial"
  }, "\n        Nacogdoches\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 205,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 378.03,
    width: 50.84,
    height: 52.44,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.168000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 404.25,
    fontFamily: "Arial"
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 206,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 430.47,
    width: 50.84,
    height: 52.74,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 456.84000000000003,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 207,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 483.21,
    width: 50.84,
    height: 53.97,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.262857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 510.195,
    fontFamily: "Arial"
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 208,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 537.18,
    width: 50.84,
    height: 54.06,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.262857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 564.2099999999999,
    fontFamily: "Arial"
  }, "\n        De_Witt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 209,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 591.24,
    width: 50.84,
    height: 54.35,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.473333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 618.415,
    fontFamily: "Arial"
  }, "\n        Potter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 210,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 645.59,
    width: 50.84,
    height: 54.41,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 171.03000000000003,
    y: 672.7950000000001,
    fontFamily: "Arial"
  }, "\n        Rusk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 211,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 169.29,
    width: 52.05,
    height: 55.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.475,
    y: 196.825,
    fontFamily: "Arial"
  }, "\n        Erath\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 212,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.5,
    y: 169.29,
    width: 52.17,
    height: 55.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.434000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.585,
    y: 196.825,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 213,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.67,
    y: 169.29,
    width: 53.79,
    height: 55.07,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.758
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.565,
    y: 196.825,
    fontFamily: "Arial"
  }, "\n        Cooke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 214,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.46,
    y: 169.29,
    width: 53.83,
    height: 55.07,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.981111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.375,
    y: 196.825,
    fontFamily: "Arial"
  }, "\n        Guadalupe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 215,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.29,
    y: 169.29,
    width: 54.46,
    height: 55.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.446
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.52000000000004,
    y: 196.825,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 216,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.76,
    y: 169.29,
    width: 56.66,
    height: 55.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.118888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.09,
    y: 196.825,
    fontFamily: "Arial"
  }, "\n        Henderson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 217,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.42,
    y: 169.29,
    width: 58.18,
    height: 55.07,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.88375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 548.51,
    y: 196.825,
    fontFamily: "Arial"
  }, "\n        Angelina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 218,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.59,
    y: 169.29,
    width: 58.77,
    height: 55.07,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.014
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.975,
    y: 196.825,
    fontFamily: "Arial"
  }, "\n        Bowie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 219,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.36,
    y: 169.29,
    width: 63.64,
    height: 55.07,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.867142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.1800000000001,
    y: 196.825,
    fontFamily: "Arial"
  }, "\n        Hopkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 220,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 224.36,
    width: 63.96,
    height: 55.23,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.42999999999998,
    y: 251.97500000000002,
    fontFamily: "Arial"
  }, "\n        Hidalgo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 221,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 279.59,
    width: 63.96,
    height: 55.3,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.216666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.42999999999998,
    y: 307.23999999999995,
    fontFamily: "Arial"
  }, "\n        Nueces\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 222,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 334.89,
    width: 63.96,
    height: 56.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.42999999999998,
    y: 363.22499999999997,
    fontFamily: "Arial"
  }, "\n        Van_Zandt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 223,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 391.56,
    width: 63.96,
    height: 57.8,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.42999999999998,
    y: 420.46,
    fontFamily: "Arial"
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 224,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 449.36,
    width: 63.96,
    height: 59.75,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.958333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.42999999999998,
    y: 479.235,
    fontFamily: "Arial"
  }, "\n        Lavaca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 225,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 509.11,
    width: 63.96,
    height: 61.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.844444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.42999999999998,
    y: 539.91,
    fontFamily: "Arial"
  }, "\n        Limestone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 226,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 570.71,
    width: 63.96,
    height: 64.41,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.42999999999998,
    y: 602.9150000000001,
    fontFamily: "Arial"
  }, "\n        Eastland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 227,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.45,
    y: 635.12,
    width: 63.96,
    height: 64.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.792
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 228.42999999999998,
    y: 667.56,
    fontFamily: "Arial"
  }, "\n        Smith\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 228,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.4,
    y: 224.36,
    width: 58.45,
    height: 71.46,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 289.625,
    y: 260.09000000000003,
    fontFamily: "Arial"
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 229,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.86,
    y: 224.36,
    width: 58.9,
    height: 71.46,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.816666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 348.31,
    y: 260.09000000000003,
    fontFamily: "Arial"
  }, "\n        Denton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 230,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 377.75,
    y: 224.36,
    width: 60.66,
    height: 71.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.132
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.08,
    y: 260.09000000000003,
    fontFamily: "Arial"
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 231,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.42,
    y: 224.36,
    width: 64.26,
    height: 71.46,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.852
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 470.55,
    y: 260.09000000000003,
    fontFamily: "Arial"
  }, "\n        Milam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 232,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.68,
    y: 224.36,
    width: 65.49,
    height: 71.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.355714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.425,
    y: 260.09000000000003,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 233,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 568.17,
    y: 224.36,
    width: 65.56,
    height: 71.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.926666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.9499999999999,
    y: 260.09000000000003,
    fontFamily: "Arial"
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 234,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.74,
    y: 224.36,
    width: 66.26,
    height: 71.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.465714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.87,
    y: 260.09000000000003,
    fontFamily: "Arial"
  }, "\n        Kaufman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 235,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.4,
    y: 295.82,
    width: 66.69,
    height: 72.71,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.745,
    y: 332.175,
    fontFamily: "Arial"
  }, "\n        Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 236,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.4,
    y: 368.54,
    width: 66.69,
    height: 81.33,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.527142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.745,
    y: 409.20500000000004,
    fontFamily: "Arial"
  }, "\n        Navarro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 237,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.4,
    y: 449.87,
    width: 66.69,
    height: 82.39,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.669
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.745,
    y: 491.065,
    fontFamily: "Arial"
  }, "\n        Williamson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 238,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.4,
    y: 532.26,
    width: 66.69,
    height: 82.83,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.745,
    y: 573.675,
    fontFamily: "Arial"
  }, "\n        Galveston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 239,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260.4,
    y: 615.09,
    width: 66.69,
    height: 84.91,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 293.745,
    y: 657.5450000000001,
    fontFamily: "Arial"
  }, "\n        Hunt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 240,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.09,
    y: 295.82,
    width: 68.5,
    height: 89.77,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.785714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.34,
    y: 340.705,
    fontFamily: "Arial"
  }, "\n        Wichita\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 241,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.59,
    y: 295.82,
    width: 73.01,
    height: 89.77,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.602
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.09499999999997,
    y: 340.705,
    fontFamily: "Arial"
  }, "\n        Ellis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 242,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.61,
    y: 295.82,
    width: 75.64,
    height: 89.77,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.606666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506.43,
    y: 340.705,
    fontFamily: "Arial"
  }, "\n        Collin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 243,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.25,
    y: 295.82,
    width: 76.38,
    height: 89.77,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.44,
    y: 340.705,
    fontFamily: "Arial"
  }, "\n        Bell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 244,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.63,
    y: 295.82,
    width: 79.37,
    height: 89.77,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.228333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.315,
    y: 340.705,
    fontFamily: "Arial"
  }, "\n        Travis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 245,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.09,
    y: 385.59,
    width: 99.49,
    height: 75.32,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.835,
    y: 423.25,
    fontFamily: "Arial"
  }, "\n        Grayson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 246,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.09,
    y: 460.91,
    width: 99.49,
    height: 78.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.76625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.835,
    y: 499.975,
    fontFamily: "Arial"
  }, "\n        McLennan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 247,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.09,
    y: 539.04,
    width: 99.49,
    height: 78.39,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.835,
    y: 578.235,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 248,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.09,
    y: 617.43,
    width: 99.49,
    height: 82.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.795714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.835,
    y: 658.7149999999999,
    fontFamily: "Arial"
  }, "\n        El_Paso\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 249,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.58,
    y: 385.59,
    width: 129.27,
    height: 124.23,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.747142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 491.215,
    y: 447.705,
    fontFamily: "Arial"
  }, "\n        Tarrant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 250,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.86,
    y: 385.59,
    width: 144.14,
    height: 124.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.9300000000001,
    y: 447.705,
    fontFamily: "Arial"
  }, "\n        Bexar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 251,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.58,
    y: 509.83,
    width: 123.83,
    height: 190.17,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.638333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.495,
    y: 604.915,
    fontFamily: "Arial"
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 252,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 550.41,
    y: 509.83,
    width: 149.59,
    height: 190.17,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 24.93166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 625.2049999999999,
    y: 604.915,
    fontFamily: "Arial"
  }, "\n        Dallas\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1924);
export default __webpack_public_path__ + "static/media/1924.bd7510c248b6f48258dec031ed0ca6af.svg";
export { ForwardRef as ReactComponent };